import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import { UserService } from '../../../client-core/services/user.service';
import { UserDto } from '../../../client-core/dtos/users.model';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'last-user-info',
    templateUrl: './last-user-component.html'
})
export class LastUserInfoComponent implements OnInit, OnChanges {
    
    @Input()
    userId: number;

    @Input()
    date: Date;

    private user: Observable<UserDto>;

    constructor(
        private userService: UserService
    ) {

    }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log('ngonchanges');
        if (changes.userId && changes.userId.currentValue) {
            let id = +(changes.userId.currentValue);
            console.log('userId', id);
            this._getUser(id);
        }
    }

    private _getUser(id: number) {
        console.log('>> LastUserInfoComponent set userId', id);
        if (id) {
            this.userService.getUser(id)
                .subscribe(res => {
                    console.log('>> LastUserInfoComponent get', res);
                    if (!res.hasError && res.data) {
                        this.user = Observable.of(res.data);
                    } else {
                        let obj = new UserDto();
                        obj.firstName = "Unknown";
                        obj.id = id;
                        this.user = Observable.of(obj);
                    }
                },
                (err: any) => {

                },
                () => {
                    //this.submitting = false;
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/last-user/last-user.component.ts